import { validateAcls } from '@redviking/argonaut-core-ui/src/auth';
import type { EntityTypeMap, ValidationResult } from 'types';

export function validateContextManageAcl (): boolean {
    return validateAcls([ 'context_update' ]);
}

export function validateContextSelectAcl (): boolean {
    return validateAcls([ 'context_select' ]);
}

export const validateContext = (_context: EntityTypeMap['context']): ValidationResult => {
    return {
        status: 'success',
    };
};
